var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevroncircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2374 3.54563C11.285 0.593266 6.49829 0.593266 3.54592 3.54563C0.593559 6.49799 0.593559 11.2847 3.54592 14.2371C6.49829 17.1894 11.285 17.1894 14.2374 14.2371C17.1897 11.2847 17.1897 6.49799 14.2374 3.54563ZM13.7401 4.04291C16.4178 6.72063 16.4178 11.0621 13.7401 13.7398C11.0624 16.4175 6.72092 16.4175 4.0432 13.7398C1.36547 11.0621 1.36547 6.72063 4.0432 4.04291C6.72092 1.36518 11.0624 1.36518 13.7401 4.04291ZM6.20005 9.47158C6.05946 9.33099 6.05946 9.10305 6.20005 8.96246L8.49108 6.67144L9.00019 6.16232L9.50931 6.67144L11.8003 8.96246C11.9409 9.10305 11.9409 9.33099 11.8003 9.47158C11.6597 9.61217 11.4318 9.61217 11.2912 9.47158L9.00019 7.18056L6.70917 9.47158C6.56858 9.61217 6.34064 9.61217 6.20005 9.47158Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevroncircle);
export default __webpack_public_path__ + "static/media/chevroncircle.c81849de778a378dbcfcde5d7d885575.svg";
export { ForwardRef as ReactComponent };